import React, { useState, useEffect, useRef } from "react";
import { useRouter } from "next/router";
import { Formik } from "formik";
import * as Yup from "yup";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { yearandgrade } from "../../helper/year";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  emailRegExp,
  phoneRegExp,
  phoneRegExpHk,
  nameRegEx,
  descriptionRegEx,
  isFormValid,
} from "@/utils/helper";

import styles from "./EnquireNow.module.css";
import LoadingSpinner from "../../components/LoadingSpinner";
import { postEnquireForm, selectData } from "../../redux/dataSlice";
import { useDispatch } from "react-redux";
import moment from "moment";
import ReCAPTCHA from "react-google-recaptcha";
import { REQUIRED, INVALID_EMAIL_ADDRESS, SPECIAL_CHAR_NOT_ALLOWED, SPECIAL_CHARS, INVALID_PHONE_NUM, INVALID_EMAIL, TOO_SHORT, TOO_LONG } from "@/utils/constants";
import { useSelector } from "react-redux";

const EnquiryForm = () => {
  const router = useRouter();

  const dispatch = useDispatch();

  const schoolData: any = useSelector(selectData);
  const obj = schoolData?.aedschoolpage;
  const schoolName = obj?.name;

  const [isChecked, setIsChecked] = useState(false);
  const [initialValues, setInitialValues] = useState<any>({
    FirstName: "",
    LastName: "",
    MobilePhone: "+971",
    Email: "",
    Student_First_Name__c: "",
    Student_Last_Name__c: "",
    Year_Grade__c: "",
    Birth_Date__c: null,
    description: "",
    // isGoldenVisa: `${isChecked}`
  });
  const [isCountry, setIsCountry] = useState<any>("");
  const [isLoading, setIsLoading] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState("");
  const [verify, setVerify] = useState(false);

  const recaptchaRef = useRef(null);

  const verify_captcha = (token: any) => {
    setVerify(true);
    setRecaptchaToken(token);
  };

  const schemaValidation = Yup.object().shape({
    FirstName: Yup.string()
      .min(3, TOO_SHORT)
      .max(50, TOO_LONG)
      .matches(nameRegEx, SPECIAL_CHAR_NOT_ALLOWED)
      .required(REQUIRED),
    LastName: Yup.string()
      .min(3, TOO_SHORT)
      .max(50, TOO_LONG)
      .matches(nameRegEx, SPECIAL_CHAR_NOT_ALLOWED)
      .required(REQUIRED),
    Email: Yup.string()
      .email(INVALID_EMAIL_ADDRESS)
      .matches(emailRegExp, { message: INVALID_EMAIL })
      .required(REQUIRED),
    Student_First_Name__c: Yup.string()
      .min(3, TOO_SHORT)
      .max(50, TOO_LONG)
      .matches(nameRegEx, SPECIAL_CHAR_NOT_ALLOWED)
      .required(REQUIRED),
    MobilePhone: Yup.string()
      .nullable()
      .required(REQUIRED)
      .matches(isCountry == "hk" ? phoneRegExpHk : phoneRegExp, {
        message: INVALID_PHONE_NUM,
      }),
    Student_Last_Name__c: Yup.string()
      .min(3, TOO_SHORT)
      .max(50, TOO_LONG)
      .matches(nameRegEx, SPECIAL_CHAR_NOT_ALLOWED)
      .required(REQUIRED),
    Year_Grade__c: Yup.string().required(REQUIRED),
    Birth_Date__c: Yup.string().required(REQUIRED),
    description: Yup.string().matches(descriptionRegEx, SPECIAL_CHARS),
  });

  useEffect(() => {
    const handleRouteChangeStart = () => setIsLoading(true);
    const handleRouteChangeComplete = () => setIsLoading(false);

    router.events.on("routeChangeStart", handleRouteChangeStart);
    router.events.on("routeChangeComplete", handleRouteChangeComplete);

    return () => {
      router.events.off("routeChangeStart", handleRouteChangeStart);
      router.events.off("routeChangeComplete", handleRouteChangeComplete);
    };
  }, [router.events]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  const hiddenData = {
    Company: null,
    ALDAR_Website_Lead_Source__c: `${window.location.href}`,
    Lead_School_Related__c: `${schoolName}`,
    LeadSource: "AE Website",
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={schemaValidation}
      onSubmit={async (values: any, { setSubmitting, resetForm }) => {
        setIsLoading(true);
        // dispatch(setLoader(true));
        try {
          await new Promise((resolve) => setTimeout(resolve, 400));
          const formattedDob = moment(values.Birth_Date__c).format(
            "YYYY-MM-DD"
          );
          const formData = {
            ...values,
            // ...hiddenData,
            from: "enquirenow",
            recaptchaToken,
            hiddenValues: { ...hiddenData },
            Birth_Date__c: formattedDob,
          };
          // const formDataArray = [formData];
          dispatch(postEnquireForm(formData));
          resetForm();
          setSubmitting(false);
          router.push("/thankyou");

        } catch (error) {
          console.error("Form submission error:", error);
        }
        setIsLoading(false);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        resetForm,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        handleBlur,
      }: any) => (
        <Form noValidate onSubmit={handleSubmit}>
          <input id="utm_source" name="utm_source__c" type="hidden" value={router.query.utm_source || ""} />
          <input id="utm_medium" name="utm_medium__c" type="hidden" value={router.query.utm_medium || ""} />
          <input id="utm_campaign" name="utm_campaign__c" type="hidden" value={router.query.utm_campaign || ""} />
          <input id="utm_content" name="utm_content__c" type="hidden" value={router.query.utm_content || ""} />
          <input id="utm_term" name="utm_term__c" type="hidden" value={router.query.utm_term || ""} />
          <input id="utm_id" name="utm_id__c" type="hidden" value={router.query.utm_id || ""} />
          <div
            className="modal fade model_enquiry"
            id="exampleModal1"
            aria-labelledby="exampleModalLabel1"
            aria-hidden="true"
            data-bs-backdrop="static"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    Thanks for your interest.
                  </h5>
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      resetForm()
                      recaptchaRef.current.reset();
                    }}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.9994 15L9 9M9.00064 15L15 9"
                        stroke="white"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
                        stroke="white"
                      />
                    </svg>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="section_tp">
                    <p>
                      Leave your contact details and our team will be in touch
                      shortly.
                    </p>
                    <h6>Contact details</h6>
                    <div className="row">
                      <div className="col-lg-6 col-12 form_field">
                        <Form.Group controlId="exampleForm.ControlInput1">
                          <Form.Label>First name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="First name"
                            name="FirstName"
                            value={values.FirstName}
                            onChange={handleChange}
                            isInvalid={touched.FirstName && !!errors.FirstName}
                          />
                          <Form.Control.Feedback type="invalid">
                            {typeof errors.FirstName === "string"
                              ? errors.FirstName
                              : ""}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                      <div className="col-lg-6 col-12 form_field">
                        <Form.Group controlId="exampleForm.ControlInput1">
                          <Form.Label>Last name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Last name"
                            name="LastName"
                            value={values.LastName}
                            onChange={handleChange}
                            isInvalid={touched.LastName && !!errors.LastName}
                          />
                          <Form.Control.Feedback type="invalid">
                            {typeof errors.LastName === "string"
                              ? errors.LastName
                              : ""}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                      <div className="col-lg-6 col-12 form_field">
                        <Form.Label>Phone</Form.Label>
                        <InputGroup>
                          <PhoneInput
                            country={"ae"}
                            placeholder={"Enter phone number *"}
                            countryCodeEditable={false}
                            value={values.MobilePhone}
                            // value={phoneNumber}
                            prefix={"+"}
                            isValid={(value, country: any) => {
                              if (value.match(/12345/)) {
                                return (
                                  "Invalid value: " +
                                  value +
                                  ", " +
                                  country.name
                                );
                              } else if (value.match(/1234/)) {
                                // invalid number
                                return false;
                              } else {
                                // valid nnnumber
                                return true;
                              }
                            }}
                            onChange={(
                              value: string,
                              data: { countryCode: string },
                              event: React.ChangeEvent<HTMLInputElement>,
                              formattedValue: string
                            ) => {
                              setIsCountry(data?.countryCode);

                              let spaceRemovedString = formattedValue
                                .substring(4, 16)
                                .replace(/\s/g, "");

                              if (spaceRemovedString?.length <= 12) {
                                let hyphenRemovedString =
                                  formattedValue.replace(/\-/g, "");
                                handleChange;
                                //   handleOnChange;
                                setFieldValue(
                                  "MobilePhone",
                                  hyphenRemovedString
                                );
                              }
                            }}
                            inputProps={{
                              name: "MobilePhone",
                              required: true,
                            }}
                            containerClass={
                              touched.MobilePhone && errors.MobilePhone
                                ? "is-invalid"
                                : ""
                            }
                          />

                          <Form.Control.Feedback type="invalid">
                            {typeof errors.MobilePhone === "string"
                              ? errors.MobilePhone
                              : ""}
                            {/* {touched.MobilePhone && errors.MobilePhone ? errors.MobilePhone : null} */}
                          </Form.Control.Feedback>
                        </InputGroup>
                      </div>
                      <div className="col-lg-6 col-12 form_field">
                        <Form.Group controlId="exampleForm.ControlInput1">
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder="Email"
                            name="Email"
                            value={values.Email}
                            onChange={handleChange}
                            isInvalid={touched.Email && !!errors.Email}
                          />
                          <Form.Control.Feedback type="invalid">
                            {typeof errors.Email === "string"
                              ? errors.Email
                              : ""}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                  <div className="section_tp">
                    <h6>Student details</h6>
                    <div className="row">
                      <div className="col-lg-6 col-12 form_field">
                        <Form.Group controlId="exampleForm.ControlInput1">
                          <Form.Label>Student first name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Student first name"
                            name="Student_First_Name__c"
                            value={values.Student_First_Name__c}
                            onChange={handleChange}
                            isInvalid={
                              touched.Student_First_Name__c &&
                              !!errors.Student_First_Name__c
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {typeof errors.Student_First_Name__c === "string"
                              ? errors.Student_First_Name__c
                              : ""}
                          </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId="exampleForm.ControlInput1">
                          <Form.Label>Year/Grade</Form.Label>
                          <Form.Select
                            aria-label="Default select example"
                            name="Year_Grade__c"
                            value={values.Year_Grade__c}
                            onChange={handleChange}
                            isInvalid={
                              touched.Year_Grade__c && !!errors.Year_Grade__c
                            }
                          >
                            {yearandgrade.levels.map((level, index) => (
                              <option key={index} value={level.value}>
                                {level.name}
                              </option>
                            ))}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {typeof errors.Year_Grade__c === "string"
                              ? errors.Year_Grade__c
                              : ""}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                      <div className="col-lg-6 col-12 form_field">
                        <Form.Group controlId="exampleForm.ControlInput1">
                          <Form.Label>Student last name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Student last name"
                            name="Student_Last_Name__c"
                            value={values.Student_Last_Name__c}
                            onChange={handleChange}
                            isInvalid={
                              touched.Student_Last_Name__c &&
                              !!errors.Student_Last_Name__c
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {typeof errors.Student_Last_Name__c === "string"
                              ? errors.Student_Last_Name__c
                              : ""}
                          </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId="exampleForm.ControlInput1">
                          <Form.Label>Date of birth</Form.Label>
                          <span className="dateInput dateOnlyInput">
                            <DatePicker
                              selected={values.Birth_Date__c}
                              onChange={(date: any) =>
                                setFieldValue("Birth_Date__c", date)
                              }
                              onBlur={handleBlur}
                              name="Birth_Date__c"
                              showYearDropdown
                              showMonthDropdown
                              scrollableYearDropdown
                              // shouldCloseOnSelect={false}
                              yearDropdownItemNumber={60}
                              dateFormat="MM/dd/yyyy"
                              className={`form-control ${touched.Birth_Date__c && errors.Birth_Date__c
                                  ? "is-invalid"
                                  : ""
                                }`}
                              maxDate={
                                new Date(new Date().getFullYear() - 1, 11, 31)
                              }
                              placeholderText="DD/MM/YYYY"
                            // customInput={<input type="text" id="00NUz0000000KoL" name="Birth_Date__c"   />}
                            />
                          </span>
                          {typeof errors.Birth_Date__c === "string" ? (
                            <div className={styles.invalid_feedback}>
                              {errors.Birth_Date__c}
                            </div>
                          ) : (
                            ""
                          )}
                        </Form.Group>
                      </div>

                      <div className="col-lg-12 col-12 form_field">
                        <Form.Group controlId="exampleForm.ControlInput1">
                          <Form.Label>Message</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Message"
                            name="description"
                            value={values.description}
                            onChange={handleChange}
                            isInvalid={
                              touched.description && !!errors.description
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {typeof errors.description === "string"
                              ? errors.description
                              : ""}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>

                      <div className="col-12 form_field main_captcha_btn mb-3 mb-xl-0">

                        <div className="captcha_sec">
                          <div className="recaptcha-container">
                            <ReCAPTCHA
                              ref={recaptchaRef}
                              sitekey={process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY_V2}
                              onChange={verify_captcha}
                            />
                          </div>
                          <div>
                            {!verify && (
                              <p className={styles.invalid_feedback}>
                                {"Please verify the Captcha"}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className=" form_field btn_submits">
                          <button
                            className="btn btn_orange mt-lg-5 mt-4"
                            type="submit"
                            data-bs-dismiss={
                              values.Birth_Date__c &&
                                Object.keys(errors).length === 0
                                ? "modal"
                                : null
                            }
                            // data-bs-dismiss={(formSubmitted && Object.keys(errors).length === 0) || (!isSubmitting && Object.keys(errors).length === 0 && formSubmitted) ? "modal" : null}
                            // id="hiddenSubmitButton"
                            // disabled={isSubmitting}
                            // disabled={verify && isFormValid(values)}
                            disabled={!recaptchaToken}
                          >
                            Confirm & continue
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );

};

export default EnquiryForm;
